import React from 'react';

const renderField = React.forwardRef(({ input, meta, shouldRound, ...rest }, ref) => (
  <div className="mb-1" ref={ref}>
    <input
      {...input}
      {...rest}
      className={`form-control ${shouldRound !== false ? 'rounded-5 py-2' : 'rounded-2 py-4'} ${meta.error && meta.touched ? 'border-danger' : ''}`}
      style={{ outline: 'none', boxShadow: 'none' }}
    />
    {meta.touched && meta.error && (
      <p className="text-danger small mt-1 ps-2 mb-0 fw-bold">{meta.error}</p>
    )}
  </div>
));
  

export default renderField;